var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "china-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff4b55 } \n\t\t.s1 { fill: #ffe15a } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0 0h20v20h-20z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m4.5 3.4l0.5 1.5h1.5c0.2 0 0.3 0.3 0.1 0.4l-1.2 0.9 0.5 1.5c0 0.2-0.2 0.4-0.4 0.3l-1.2-1-1.3 1c-0.2 0.1-0.4-0.1-0.3-0.3l0.4-1.5-1.2-0.9c-0.2-0.1-0.1-0.4 0.1-0.4h1.6l0.5-1.5c0-0.2 0.3-0.2 0.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m10.2 3.8l0.3 0.5 0.6-0.2c0.1 0 0.1 0 0.1 0.1l-0.4 0.5 0.4 0.5c0 0 0 0.1-0.1 0.1l-0.6-0.2-0.3 0.5c-0.1 0.1-0.2 0-0.2 0v-0.6l-0.6-0.2c0-0.1 0-0.2 0-0.2l0.6-0.2v-0.6c0-0.1 0.1-0.1 0.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m8 2.3l0.6 0.1 0.2-0.6c0.1 0 0.2 0 0.2 0.1l0.1 0.6h0.6c0.1 0 0.1 0.1 0 0.2l-0.5 0.3 0.1 0.6c0.1 0 0 0.1-0.1 0l-0.4-0.4-0.6 0.3c0 0.1-0.1 0-0.1-0.1l0.3-0.5-0.5-0.4c0-0.1 0-0.2 0.1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m8.9 8.2l-0.3 0.4-0.6-0.1c-0.1-0.1-0.1 0-0.1 0.1l0.4 0.5-0.4 0.5c0 0 0 0.1 0.1 0.1l0.6-0.2 0.3 0.5c0.1 0.1 0.2 0 0.2 0v-0.7l0.6-0.1c0-0.1 0-0.2 0-0.2l-0.6-0.2v-0.6c0-0.1-0.1-0.1-0.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m11.1 6.8l-0.6 0.1-0.2-0.6c-0.1 0-0.2 0-0.2 0l-0.1 0.6-0.6 0.1c-0.1 0-0.1 0.1-0.1 0.2l0.6 0.3-0.1 0.5c-0.1 0.1 0 0.2 0.1 0.1l0.4-0.4 0.6 0.3c0 0 0.1 0 0.1-0.1l-0.3-0.5 0.5-0.5c0 0 0-0.1-0.1-0.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.e1be04720bb97ae98b5bd0becee11d1f.svg";
export { ForwardRef as ReactComponent };